import React, { useState, createContext, memo, useEffect } from "react";
import styles from "./App.module.scss";
import ContactTo from "./ContactTo";
import Category from "./Category";
import Showroom from "./Showroom";
import FormMain from "./FormMain";
import FormShowroom from "./FormShowroom";
import FormBusiness from "./FormBusiness";
import User from "./User";
import Customer from "./Customer";
import Body from "./Body";
import Privacy from "./Privacy";
import AddFiles from "./AddFiles";

export const Data = createContext();

const App = memo(() => {
	const [inputs, setInputs] = useState({
		contactTo: null,
		category: null,
		showroom: null,
		subject: "default",
		name: null,
		furigana: null,
		email: null,
		uname: null,
		ufurigana: null,
		postcode: null,
		address: null,
		tel: null,
		sample: null,
		body: null,
		mobile: navigator.userAgent.match(/iPhone|Android.+Mobile/) ? true : false,
		company: null,
		url: null,
		industry: "default",
	});
	const [errors, setErrors] = useState({
		subject: null,
		name: "*必須",
		furigana: "*必須",
		email: "*必須",
		emailCheck: "*必須",
		body: "*必須",
		privacy: "*必須",
	});
	const value = { inputs, setInputs, errors, setErrors };

	const [noError, setNoError] = useState(false);
	useEffect((e) => {
		let errorCount = Object.values(errors).reduce(
			(sum, elm) => (elm === null ? sum : sum + 1),
			0
		);
		if (errorCount > 0) {
			setNoError(false);
		} else {
			setNoError(true);
		}
	}, [errors]);

	return (
		<div className={styles.formWrapper}>
			<Data.Provider value={value}>
				<ContactTo />
				{inputs.contactTo === "カスタマーサポート" ? <Category /> : <></>}
				{inputs.contactTo === "各ショールーム" ? <Showroom /> : <></>}
				{inputs.contactTo === "法人のお客様" ? <FormBusiness /> : <></>}
				{inputs.showroom !== null ? <FormShowroom /> : <></>}
				{inputs.category !== null ? <FormMain /> : <></>}
				{inputs.category === "ソファを検討中" ? <Customer /> : <></>}
				{inputs.category === "ソファを使用中" ? <User /> : <></>}
				{(inputs.category !== null || inputs.showroom !== null || inputs.contactTo === "法人のお客様") && (
					<>
						<Body />
						<AddFiles />
						<Privacy />
						<button
							className={styles.submitBtn}
							type="submit"
							disabled={noError ? false : true}
						>
							送信する
						</button>
						<p className={styles.infoText}>
							<span className={styles.required}>＊</span>
							印の付いている項目は必須項目です。<br></br>
							ご選択、ご入力をお確かめくださいませ。
						</p>
					</>
				)}
			</Data.Provider>
			<input type="hidden" name="mobile" value={inputs.mobile} />
		</div>
	);
});

export default App;
